import ScrollMagic from "scrollmagic";
import html2canvas from "html2canvas";

export default {
    init() {
        // JavaScript to be fired on all pages
        const bodyElem = $("body");

        const $menu = $(".menu");
        $menu.find(".label .bars").on("click", function () {
            $menu.addClass("open");
            $menu.find(".label .cross").addClass("show");
            $menu.find(".menu-content .cross-mob").addClass("show");
            $menu.find(".label .bars").addClass("hide");
            $("body").addClass("stop-scroll");
            bodyElem.toggleClass("disableBodyScroll");

        });

        $menu.find(".label .bars").swipe({
            swipeRight: function () {
                $menu.addClass("open");
                $menu.find(".label .cross").addClass("show");
                $menu.find(".menu-content .cross-mob").addClass("show");
                $menu.find(".label .bars").addClass("hide");
                $("body").addClass("stop-scroll");
                bodyElem.toggleClass("disableBodyScroll");
            },
        });

        $menu.find(".cross").on("click", function () {
            $menu.removeClass("open");
            $menu.find(".label .bars").removeClass("hide");
            $menu.find(".label .cross").removeClass("show");
            $menu.find(".menu-content .cross-mob").removeClass("show");
            $("body").removeClass("stop-scroll");
            bodyElem.toggleClass("disableBodyScroll");
        });
        $menu.find(".cross-mob").on("click", function () {
            $menu.removeClass("open");
            $menu.find(".label .bars").removeClass("hide");
            $menu.find(".menu-content .cross-mob").removeClass("show");
            $menu.find(".label .cross").removeClass("show");
            $("body").removeClass("stop-scroll");
            bodyElem.toggleClass("disableBodyScroll");
        });

        const $search = $(".search-menu");

        $search.find(".label .find").on("click", function () {
            $search.addClass("open");
            $search.find(".label .crosses").addClass("show");
            $search.find(".search-content .crosses-mob").addClass("show");
            $search.find(".label .find").addClass("hide");
            $("body").addClass("stop-scroll");
            bodyElem.toggleClass("disableBodyScroll");
        });

        $search.find(".label .find").swipe({
            swipeLeft: function () {
                $search.addClass("open");
                $search.find(".label .crosses").addClass("show");
                $search.find(".search-content .crosses-mob").addClass("show");
                $search.find(".label .find").addClass("hide");
                $("body").addClass("stop-scroll");
            },

        });


        $search.find(".crosses").on("click", function () {
            $search.removeClass("open");
            $search.find(".label .find").removeClass("hide");
            $search.find(".label .crosses").removeClass("show");
            $search.find(".search-content .crosses-mob").removeClass("show");
            $("body").removeClass("stop-scroll");
            bodyElem.toggleClass("disableBodyScroll");
        });
        /* Icon close mobile */
        $search.find(".crosses-mob").on("click", function () {
            $search.removeClass("open");
            $search.find(".label .find").removeClass("hide");
            $search.find(".label .crosses").removeClass("show");
            $search.find(".search-content .crosses-mob").removeClass("show");
            $("body").removeClass("stop-scroll");
            bodyElem.toggleClass("disableBodyScroll");
        });

        $(".block-contact .pi-privacy .wpcf7-list-item").append("<span class=\"pigreco-checkmark\"></span>");
        $(".custom-tooltip").append("<span class=\"tooltiptext\">Acconsento al trattamento dei dati personali in qualità di interessato, avendo letto l’informativa privacy policy redatta ai sensi dell’articolo 23 del D.Lgs. n. 196/2003 e s.m.i.." +
            "<br/><br/>Acconsento espressamente al trattamento dei dati personali per finalità di marketing ed invio di materiale pubblicitario relativo ad iniziative, prodotti e servizi della Società, sia con mezzi automatizzati senza intervento dell’operatore (es. newsletter, sms, mms, posta elettronica, ecc) che tradizionali (tramite telefono, posta) e/o tramite aree riservate e private del Sito Internet." +
            "<br/><br/>Acconsento espressamente al trattamento dei Suoi dati personali per finalità di profilazione a scopi di pubblicità comportamentale." +
            "<br/><br/>Acconsento espressamente al trattamento dei Suoi dati personali per finalità di indagini di mercato e sulla soddisfazione della clientela, mediante interviste personali o telefoniche, o altri mezzi di rilevazione (questionari, ecc)" +
            "<div class='arrow-down'><div class='arrow'></div></div></span>");


        var formElemNL = $(".block-contact .form-elem");

        formElemNL.each(function () {

            let elem = $(this);

            /* INPUT */

            $(this).find("input").focusin(function () {
                elem.find("label.pi-label").addClass("active-input");
            });

            $(this).focusout(function () {
                if ($(this).find("input").val() === "") {
                    elem.find("label.pi-label").removeClass("active-input");
                }
            });

            /* TEXTAREA */

            $(this).find("textarea").focusin(function () {
                elem.find("label.pi-label").addClass("active-input");
            });

            $(this).focusout(function () {
                if ($(this).find("textarea").val() === "") {
                    elem.find("label.pi-label").removeClass("active-input");
                }
            });

            /* SELECT */
            $(this).find("select").focusin(function () {
                elem.find("label.pi-label").addClass("active-input");
            });

            $(this).focusout(function () {
                if ($(this).find("select").val() === "") {
                    elem.find("label.pi-label").removeClass("active-input");
                }
            });

        });

        var searchElem = $(".search-input");

        searchElem.each(function () {

            let elem = $(this);

            /* INPUT */

            $(this).find("input").focusin(function () {
                elem.find("label.pi-label").addClass("active-input");
            });


            $(this).focusout(function () {
                if ($(this).find("input").val() === "") {
                    elem.find("label.pi-label").removeClass("active-input");
                }
            });
        });

        $("body").addClass("stop-scroll");

        const authIcon = $(".auth-button-reserved");
        const authPopup = $(".popup-autenthication");

        authIcon.click(function (event) {
            event.stopPropagation();
            authPopup.addClass("bounceIn");

            authPopup.on("animationend", function () {
                $(this).addClass("open");
                $(this).off("animationend");
            });
        });

        bodyElem.click(function () {
            if (authPopup.hasClass("open")) {
                authPopup.removeClass("bounceIn");
                authPopup.addClass("bounceOut");
                authPopup.on("animationend", function () {
                    $(this).removeClass("bounceOut");
                    $(this).removeClass("open");
                    $(this).off("animationend");
                });
            }
        });

        var formAuth = $(".um-form form .um-field-area");

        formAuth.each(function () {

            let elemAuth = $(this);

            if ($(this).find("input").val() !== "") {
                elemAuth.siblings(".um-field-label").find("label").addClass("active-input");
            }

            /* INPUT */
            $(this).find("input").focusin(function () {
                elemAuth.siblings(".um-field-label").find("label").addClass("active-input");
            });

            $(this).focusout(function () {
                if ($(this).find("input").val() === "") {
                    elemAuth.siblings(".um-field-label").find("label").removeClass("active-input");
                }
            });

            /* TEXTAREA */
            $(this).find("textarea").focusin(function () {
                elemAuth.siblings(".um-field-label").find("label").addClass("active-input");
            });

            $(this).focusout(function () {
                if ($(this).find("textarea").val() === "") {
                    elemAuth.siblings(".um-field-label").find("label").removeClass("active-input");
                }
            });
        });

        /* JS PER GENERAZIONE FILE TXT CON DATI QUESTIONARIO */
        function getAnswers() {
            var textToSave = [];
            var questions = $(".quiz-container .form-elem");

            questions.each(function () {
                var line = "";
                var quest = $(this);
                var title = quest.find(".question").text();
                var inputs = quest.find(":input");

                line = title + "\n";

                inputs.each(function () {
                    var inputType = $(this).attr("type");

                    if (inputType == "checkbox" || inputType == "radio") {
                        if ($(this).prop("checked")) {
                            line = line + " - " + $(this).val() + "\n";
                        }
                    } else {
                        line = line + " - " + $(this).val() + "\n";
                    }
                });

                textToSave.push(line + "\n");
            });
            saveTextAsFile(textToSave);
        }

        function saveTextAsFile(textToSave) {
            var correctAnswer = textToSave.join("");
            var textToSaveAsBlob = new Blob([correctAnswer], {type: "text/plain", endings: "native"});
            var textToSaveAsURL = window.URL.createObjectURL(textToSaveAsBlob);
            var downloadLink = document.createElement("a");

            downloadLink.download = "risposte-questionario-orientati";
            downloadLink.innerHTML = "Download File";
            downloadLink.href = textToSaveAsURL;
            downloadLink.onclick = destroyClickedElement;
            downloadLink.style.display = "none";
            document.body.appendChild(downloadLink);

            downloadLink.click();
        }

        function destroyClickedElement(event) {
            document.body.removeChild(event.target);
        }

        $("#get-answer-click").click(function () {
            getAnswers();
        });

        if ($("#get-page-screenshot").length > 0) {
            /* JS PER SCREENSHOT PAGINA */
            document.getElementById("get-page-screenshot").addEventListener("click", function () {

                html2canvas(document.querySelector(".single-questionari")).then(function (canvas) {
                    saveAs(canvas.toDataURL(), "immagine-questionario-orientati.jpg");
                });
            });
        }

        function saveAs(uri, filename) {
            var link = document.createElement("a");

            if (typeof link.download === "string") {

                link.href = uri;
                link.download = filename;

                //Firefox requires the link to be in the body
                document.body.appendChild(link);

                //simulate click
                link.click();

                //remove the link when done
                document.body.removeChild(link);

            } else {

                window.open(uri);

            }
        }


    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

    },
    onLoad() {
        const bodyElem = $("body");
        /*
                $(".loader-piece").each(function(){
                    $(this).on("animationiteration webkitAnimationIteration", function(){
                        $(this).css({"animation":"none", "opacity" : 1});
                    });
                });
        */
        $(".loader-bg").addClass("loader-bg-end");
        $("body").removeClass("stop-scroll");
        /*
        if (location.pathname != "/") {
            let menuText = $("#breadcrumbs > span").text().split(" ")[2].toLowerCase();
            $(".navbar li > a").each(function () {
                if (this.pathname.search(menuText) != -1) {
                    $(this).parent().addClass("current-menu-item current_page_item active");
                }
            });
        }
        */

        const $pageHeaderBrand = $(".page-header .brand");
        if ($pageHeaderBrand.length > 0) {
            $pageHeaderBrand.height($pageHeaderBrand.width());

            $(window).resize(function () {
                $pageHeaderBrand.height($pageHeaderBrand.width());
            });
        }

        const $pageHeaderGoBack = $(".page-header .go-back");
        if ($pageHeaderGoBack.length > 0) {
            $pageHeaderGoBack.find("a").attr("href", $(".breadcrumb_last").siblings("a").attr("href"));
        }

        let text_controller = new ScrollMagic.Controller();
        let text_scene;

        if ($(".container-page").height() - $(".contact-pinned").height() > 0 && $(window).width() > 991) {

            text_controller.removeScene(text_scene);
            text_scene = new ScrollMagic.Scene({
                triggerElement: "#pin-fixed",
                triggerHook: "onLeave",
                duration: $(".container-page").height(),
            })
                .setPin(".contact-pinned")
                //.addIndicators()
                .addTo(text_controller);
        }

        $(".card > .card-body > .label").each(function () {
            $(this).on("click", function () {
                $(this).hover();
            });
        });

        if (bodyElem.hasClass("um-own-profile")) {
            $(".um-viewing .um-profile-body").append("<a href=\" " + window.location.href + "?profiletab=main&um_action=edit \" class='um-button'>Modifica il profilo</a>");
            $(".um-password > .um-form > form > .um-field-text > .um-field-area > input").removeAttr("placeholder");
            $(".um-password > .um-form > form > .um-field-text ").prepend("<div class= \"um-field-label\"> <label> Inserisci il tuo indirizzo E-mail</label></div>");
        }

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js